import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api/api.service';
import { Observable } from 'rxjs';

export interface Survey {
  id?: number;
  name: string;
  startDate: Date;
  endDate: Date;
  description?: string;
  surveyType: any;
  isActive: boolean;
  isEmployeeSurvey?: boolean;
  caseTypes?: any[];
  kindOfSurvey?:any;
  questions?: Question[];
}

export interface Question {
  id?: number;
  name: string;
  code: string;
  description?:string;
  answerType: string;
  answerValues?: string[];
  receivedService?:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SurveyDefinitionService {

  constructor(private readonly apiService: ApiService) { }

  getAll(filter?: any): Observable<Survey[]> {
    return this.apiService.get<Survey[]>(`surveys/get-all`, filter);
  }


  create(survey: Survey): Observable<Survey> {
    return this.apiService.post<Survey>(`surveys/create`, survey);
  }

  update(id: number, survey: Survey): Observable<Survey> {
    return this.apiService.put<Survey>(`surveys/update/${id}`, survey);
  }

  getIsActiveAndTodayIncludes() {
    return this.apiService.get<Survey[]>(`surveys/get-all-isActive`);
  }



  getSurveyById(id: number, caseId?: number) { // İlgili Anket Sorularını Alır GİDİCİ
    return this.apiService.get<Survey[]>(`surveys/get-survey-by-id/${id}/${caseId}`);
  }

  submitResponses(responses: any[]): Observable<any> { //İlgili anketin Cevaplarını Kaydeder  GİDİCİ
    return this.apiService.post('surveys/responses', responses);
  }

  getCaseAnswers(caseId: number, surveyId?: number) { // bu kalacak
    let url = `surveys/get-case-answers/${caseId}`;
    if (surveyId) {
      url += `?surveyId=${surveyId}`;
    }
    return this.apiService.get<any>(url);
  }

  /*** Yeniden Başlıyoruz */

  getSurveyQuestions(surveySearchId: number, type?: string) {
    const url = `surveys/get-survey-questions/${surveySearchId}` + (type ? `?type=${type}` : '');
    return this.apiService.get<any[]>(url);
  }

  sendSurveyAnswers(responses:any[]){
    return this.apiService.post('surveys/send-survey-responses', responses);
  }

  getSurveyQuestionsIndepented(surveySearchId: number, type?: string) {
    const url = `surveys/get-survey-questions-independent/${surveySearchId}` + (type ? `?type=${type}` : '');
    return this.apiService.get<any[]>(url);
  }

  sendSurveyAnswersIndepented(responses:any[]){
    return this.apiService.post('surveys/send-survey-responses-independent', responses);
  }

  sendSurveySMS(data:any){
    return this.apiService.post('surveys/send-survey-sms', data);

  }
}
